import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const applyTheme = useCallback((s) => {
    const root = document.documentElement;
    if (s.font_heading) root.style.setProperty("--font-heading", s.font_heading);
    if (s.font_body) root.style.setProperty("--font-body", s.font_body);
    if (s.font_size_base) root.style.fontSize = `${s.font_size_base}px`;
    if (s.primary_color) root.style.setProperty("--primary", s.primary_color);
    if (s.accent_color) root.style.setProperty("--accent", s.accent_color);
    if (s.accent_color) root.style.setProperty("--ring", s.primary_color || s.accent_color);

    if (s.adsense_enabled && s.adsense_client && !document.getElementById("adsense-script")) {
      const sc = document.createElement("script");
      sc.id = "adsense-script";
      sc.async = true;
      sc.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${s.adsense_client}`;
      sc.crossOrigin = "anonymous";
      document.head.appendChild(sc);
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/settings");
      setSettings(res.data);
      applyTheme(res.data);
    } catch (e) {}
  }, [applyTheme]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, applyTheme }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
